export default class FooterLinks {
  constructor() {
    this.toggle = this.toggle.bind(this);
    this.footerSectionHeaders = document.getElementsByClassName('js-toggle-item');
  }

  // eslint-disable-next-line class-methods-use-this
  toggle({ currentTarget }) {
    const name = currentTarget.getAttribute('name');
    const clickedSection = currentTarget.closest('.js-toggle-item-container');
    const isActive = clickedSection.getAttribute('active');
    const siblingSections = document.querySelectorAll(`.js-toggle-item-container[name=${name}]`);

    [...siblingSections].forEach((element) => element.removeAttribute('active'));

    if (!isActive) {
      clickedSection.setAttribute('active', true);
    }
  }

  initializeEventListeners() {
    [...this.footerSectionHeaders].forEach((element) => element.addEventListener('click', this.toggle));
  }
}
